import { TemperatureType } from './enum/TemperatureType';
import { UserContextService } from '../../user-context.service';

export function getTemperature(
  temperature: number,
  fixedValue: number = 1,
  addUnit: boolean = true,
): string {
  const user = UserContextService.staticCurrentUser;

  if (user?.tempUnit === TemperatureType.FAHRENHEIT) {
    return (
      ((temperature * 9) / 5 + 32).toFixed(fixedValue) + (addUnit ? '°F' : '')
    );
  } else {
    return temperature.toFixed(fixedValue) + (addUnit ? '°C' : '');
  }
}

export function getTemperatureUnit(): string {
  const user = UserContextService.staticCurrentUser;

  if (user?.tempUnit === TemperatureType.FAHRENHEIT) {
    return '°F';
  } else {
    return '°C';
  }
}

export function getTemperatureType(): TemperatureType {
  const user = UserContextService.staticCurrentUser;

  if (user?.tempUnit === TemperatureType.FAHRENHEIT) {
    return TemperatureType.FAHRENHEIT;
  } else {
    return TemperatureType.CELSIUS;
  }
}
